import { FetchWrapperPost } from "./FetchWrapperPost";

export const FetchWrapper = async (url, requestMethod) => {
 return FetchWrapperPost(url, requestMethod,null)
};
